var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepperSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    y: 0.326172,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C6E4F3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Dot",
    cx: 10.6406,
    cy: 10.3262,
    r: 7.5,
    fill: "#C6E4F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1071 7.07023C14.2533 6.92002 14.4523 6.83261 14.6618 6.82651C14.8242 6.82183 14.9842 6.86636 15.121 6.95415C15.2577 7.04193 15.3647 7.16906 15.4281 7.31868C15.4914 7.4683 15.5081 7.6332 15.476 7.79247C15.4438 7.95173 15.3644 8.09774 15.248 8.2111L9.86929 13.5898C9.71798 13.7411 9.51279 13.8262 9.29885 13.8262C9.08491 13.8262 8.87973 13.7411 8.72841 13.5898L6.03906 10.9005C5.96163 10.8261 5.89981 10.7369 5.85722 10.6383C5.81464 10.5398 5.79215 10.4337 5.79106 10.3263C5.78997 10.219 5.8103 10.1127 5.85087 10.0133C5.89145 9.9139 5.95144 9.82393 6.02734 9.74802C6.10325 9.67212 6.19352 9.61211 6.2929 9.57153C6.39228 9.53096 6.49877 9.51056 6.6061 9.51165C6.71344 9.51275 6.81948 9.53525 6.91801 9.57784C7.01654 9.62042 7.10559 9.68215 7.17994 9.75958L9.29885 11.8785L14.1071 7.07023Z",
    fill: "#0E4965"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperSuccess);
export default __webpack_public_path__ + "static/media/StepperSuccess.0645c406430a4750e6c8bed470492e78.svg";
export { ForwardRef as ReactComponent };